var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { businessService } from "~/config/server";
import { NetService } from "~/utils/net.service";
import { Inject, Debounce } from "~/core/decorator";
var LeaveCaseService = /** @class */ (function () {
    function LeaveCaseService() {
    }
    /**
     * 留案案件查询
     */
    LeaveCaseService.prototype.queryLeaveCases = function (data, page, sort, loading) {
        return this.netService.send({
            server: businessService.leaveCaseController.queryLeaveCases,
            data: {
                principalId: data.principalId,
                batchNumber: data.batchNumber,
                personalName: data.personalName,
                certificateNo: data.certificateNo,
                caseNumber: data.caseNumber,
                cardNo: data.cardNo,
                phone: data.phone,
                stage: data.stage,
                collectStatus: data.collectStatus,
                caseStatus: data.caseStatus,
                retireCaseDays: data.retireCaseDays,
                employerName: data.employerName,
                address: data.address,
                overdueAmtTotalStart: data.overdueAmtTotal.min,
                overdueAmtTotalEnd: data.overdueAmtTotal.max,
                leftAmtStart: data.leftAmt.min,
                leftAmtEnd: data.leftAmt.max,
                paymentStatus: data.paymentStatus,
                delegationDateStart: data.delegationDate[0],
                delegationDateEnd: data.delegationDate[1],
                comment: data.comment,
                currentCollectorName: data.currentCollectorName,
                departCode: data.departCode,
                overduePeriodsStart: data.overduePeriods.min,
                overduePeriodsEnd: data.overduePeriods.max,
                overdueDaysStart: data.overdueDays.min,
                overdueDaysEnd: data.overdueDays.max,
                city: data.city,
                caseLeaveFlag: data.caseLeaveFlag,
                endCaseDateStart: data.endCaseDate[0],
                endCaseDateEnd: data.endCaseDate[1],
                caseType: data.caseType
            },
            page: page,
            sort: sort,
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], LeaveCaseService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], LeaveCaseService.prototype, "queryLeaveCases", null);
    return LeaveCaseService;
}());
export { LeaveCaseService };
